// client/src/auth-context.tsx
import { createContext, useContext, ReactNode } from 'react';
import { useAuth } from './hooks/use-auth';

// Define the type for the context based on useAuth return value
type AuthContextType = ReturnType<typeof useAuth>;

// Create the context with a default value
const AuthContext = createContext<AuthContextType | null>(null);

// Custom hook to access the context
export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}

// Provider component
export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}